export default {
  arrives: 'Aankomst',
  journeyDuration: 'Reisduur',
}
